import React, { useEffect, useState, useCallback } from 'react';
import { getTableByIdBd, getVariables, validarMobil } from '../../config/functions';
import { useHistory } from "react-router-dom";
import { Sidebar, Menu as ProMenu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderES } from '../LoaderES';
import { obtenerURLImagen } from '../../config/firebase';
import { Plantillas } from '../administracion/plantillas/Plantillas';
import { DOReport } from "../DOR/DOReport";
import { Config } from './Config';
import { detectDeviceType } from '../graficas/functionsGraphs';
import LogoutButton from './LogoutButton';
import moment from 'moment';
import LiveGraphsOptimized from '../graficasOpt/LiveGraphsOptimized';
import RigTabs from '../graficasOpt/RigTabs';
import Variables from '../administracion/variables/Variables';
import Users from '../administracion/usuarios/Users';
import VariablesForm from '../administracion/formulacion/VariablesForm';
import Help from '../ayuda/Help';
import Home from "../Home";
import MyRigs from "../MyRigs";
import Rigs from '../administracion/rigs/Rigs';
import Operadoras from '../administracion/operadoras/Operadoras';
import LiveDataOpt from '../liveDataOpt/LiveDataOpt';
import Licencias from '../administracion/licencias/Licencias';

import './css/menu.css';
import 'react-toastify/dist/ReactToastify.css';

const Menu = () => {

    const [colors, setColors] = useState({});

    const [logo, setLogo] = useState('')
    const [logoW, setLogoW] = useState('')
    const [logoTw, setLogoTw] = useState('')
    const [logoTwW, setLogoTwW] = useState('')

    const history = useHistory();

    const user = JSON.parse(localStorage.getItem("token")).userName;
    const tipo = JSON.parse(localStorage.getItem("token")).tipo;
    const uId = JSON.parse(localStorage.getItem("token")).id;
    const [reportes, setReportes] = useState(0)

    const [mobile, setMobile] = useState(true)
    const [horizontal, setHorizontal] = useState(false)
    const [tipoDispositivo, setTipoDispositivo] = useState('')

    const collapsedFromSessionStorage = sessionStorage.getItem("collapsed");
    const toggledFromSessionStorage = sessionStorage.getItem("toggled");
    const brokenFromSessionStorage = sessionStorage.getItem("broken");
    const [collapsed, setCollapsed] = useState(collapsedFromSessionStorage === 'true' ? true : false);
    const [toggled, setToggled] = useState(toggledFromSessionStorage === 'true' ? true : false);
    const [broken, setBroken] = useState(brokenFromSessionStorage === 'true' ? true : false);

    const themeFromLocalStorage = localStorage.getItem("theme");
    const [theme, setTheme] = useState(themeFromLocalStorage !== null ? themeFromLocalStorage : 'light');
    const [isLoading, setIsLoading] = useState(false)

    const [adminShow, setAdminShow] = useState(false);
    const [reloj, setReloj] = useState(moment().format('LTS'))

    const [variables, setVariables] = useState([])

    const rigFromLocalStorage = JSON.parse(localStorage.getItem("rig"));
    const [rigs, setRigs] = useState([])
    const [rig, setRig] = useState((rigFromLocalStorage === null || rigFromLocalStorage === '') ? 0 : rigFromLocalStorage);
    const [rigName, setRigName] = useState('')

    const componenteLocalStorage = localStorage.getItem('componente') || 'home'
    const [componente, setComponente] = useState(componenteLocalStorage)

    const [activoHover, setActivoHover] = useState(null);

    const [showConfig, setShowConfig] = useState(false);
    const handleClose = () => setShowConfig(false);

    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const [themes, setThemes] = useState({
        light: {
            sidebar: {
                backgroundColor: '#ffffff',
                color: '#607489',
            },
            font: { color: 'black' }
        },
        dark: {
            sidebar: {
                backgroundColor: '#070707ff',
                color: '#8ba1b7',
            },
            font: { color: 'white' }
        },
        custom: {
            sidebar: {
                backgroundColor: colors?.colorBg || '#ffffff',
                color: colors?.colorFont || '#000000',
            },
            font: { color: colors?.colorFont || '#000000' }
        }
    })

    //--------------------------------------------------------------------
    //variables para OPT
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [enVivo, setEnVivo] = useState(false);

    //--------------------------------------------------------------------
    // Tabs state - lifted from LiveGraphsOptimized
    const [openTabs, setOpenTabs] = useState(() => {
        // 🗄️ Restaurar tabs desde localStorage al montar
        try {
            const saved = localStorage.getItem('openTabs');
            return saved ? JSON.parse(saved) : [];
        } catch (e) {
            console.warn('⚠️ Error restaurando tabs desde localStorage:', e);
            return [];
        }
    });
    const [activeTabId, setActiveTabId] = useState(null);
    const [showRigSelectorInTabs, setShowRigSelectorInTabs] = useState(false);

    // 🗄️ PERSISTIR TABS EN LOCALSTORAGE cuando cambien
    useEffect(() => {
        localStorage.setItem('openTabs', JSON.stringify(openTabs));
    }, [openTabs]);

    // 🗄️ RESTAURAR ACTIVE TAB DESDE LOCALSTORAGE
    useEffect(() => {
        try {
            const saved = localStorage.getItem('activeTabId');
            if (saved) {
                const tabId = JSON.parse(saved);
                setActiveTabId(tabId);
            }
        } catch (e) {
            console.warn('⚠️ Error restaurando activeTabId:', e);
        }
    }, []); // Solo una vez al montar

    // 🗄️ PERSISTIR ACTIVE TAB cuando cambie
    useEffect(() => {
        if (activeTabId) {
            localStorage.setItem('activeTabId', JSON.stringify(activeTabId));
        }
    }, [activeTabId]);

    // 🗄️ SISTEMA DE CACHÉ MULTINIVEL PARA DATOS DE RIGS
    // Almacena datos, configuración y estado por cada rig
    const [rigDataCache, setRigDataCache] = useState(() => new Map());

    // Tab handlers - simples, solo manejan el estado
    const handleTabChange = useCallback((rigId) => {
        //console.log(`🗂️ [Menu] Cambiando a rig: ${rigId}`);
        setActiveTabId(rigId);
        setRig(rigId);
    }, [setRig]);

    const handleTabClose = useCallback((rigIdToClose) => {
        if (openTabs.length === 1) {
            console.warn('⚠️ [Menu] No se puede cerrar el único tab abierto');
            return;
        }
        
        //console.log(`🗂️ [Menu] Cerrando tab: ${rigIdToClose}`);
        
        // 🗑️ Limpiar caché del rig cerrado
        setRigDataCache(prev => {
            const newCache = new Map(prev);
            newCache.delete(parseInt(rigIdToClose));
            return newCache;
        });
        
        // Remover tab
        const newTabs = openTabs.filter(tab => tab.rigId !== rigIdToClose);
        setOpenTabs(newTabs);
        
        // Si cerramos el activo, cambiar al último tab
        if (activeTabId === rigIdToClose) {
            const newActive = newTabs[newTabs.length - 1];
            if (newActive) {
                setRig(newActive.rigId);
                setActiveTabId(newActive.rigId);
            }
        }
    }, [openTabs, activeTabId]);

    const handleAddTab = useCallback(() => {
        //console.log('📌 [Menu] Abriendo selector de rig en tabs');
        setShowRigSelectorInTabs(true);
    }, []);

    // 🗄️ FUNCIONES DE GESTIÓN DEL CACHÉ DE DATOS
    
    // Obtener datos del caché para un rig
    const getCachedRigData = useCallback((rigId) => {
        return rigDataCache.get(parseInt(rigId));
    }, [rigDataCache]);

    // Guardar datos en el caché
    const setCachedRigData = useCallback((rigId, data) => {
        setRigDataCache(prev => {
            const newCache = new Map(prev);
            newCache.set(parseInt(rigId), {
                ...data,
                lastAccessed: Date.now(),
                timestamp: Date.now()
            });
            return newCache;
        });
    }, []);

    // Actualizar parcialmente datos del caché (para catch-up)
    const updateCachedRigData = useCallback((rigId, updates) => {
        setRigDataCache(prev => {
            const newCache = new Map(prev);
            const existing = newCache.get(parseInt(rigId));
            if (existing) {
                newCache.set(parseInt(rigId), {
                    ...existing,
                    ...updates,
                    lastAccessed: Date.now()
                });
            }
            return newCache;
        });
    }, []);

    // Limpiar caché de un rig específico
    const clearCachedRigData = useCallback((rigId) => {
        setRigDataCache(prev => {
            const newCache = new Map(prev);
            newCache.delete(parseInt(rigId));
            return newCache;
        });
    }, []);

    // Handler para seleccionar rig desde el selector de tabs
    const handleSelectRigFromTabs = useCallback((selectedRigId) => {
        setShowRigSelectorInTabs(false);
        
        if (selectedRigId && selectedRigId !== 0) {
            // Verificar si ya existe un tab para este rig
            const existingTab = openTabs.find(tab => parseInt(tab.rigId) === parseInt(selectedRigId));
            
            if (existingTab) {
                // Solo activar el tab existente
                setActiveTabId(selectedRigId);
                setRig(parseInt(selectedRigId));
            } else if (openTabs.length < 6) {
                // Crear nuevo tab con los datos del rig
                const rigData = rigs.find(r => parseInt(r.nb_tldro_idn) === parseInt(selectedRigId));
                
                // Extraer nombre del rig y pozo
                let rigName, wellName;
                if (rigData?.pozo) {
                    // Si tiene el campo pozo separado
                    rigName = rigData.rig || rigData.vr_tldro_nom || `Rig ${selectedRigId}`;
                    wellName = rigData.pozo;
                } else {
                    // Extraer del nombre completo separado por guion
                    const fullName = rigData?.vr_tldro_nom || rigData?.rig || `Rig ${selectedRigId}`;
                    const parts = fullName.split('-');
                    if (parts.length >= 2) {
                        rigName = parts[0].trim();
                        wellName = parts.slice(1).join('-').trim();
                    } else {
                        rigName = fullName;
                        wellName = 'Sin pozo';
                    }
                }
                
                const newTab = {
                    rigId: selectedRigId,
                    rigName: rigName,
                    wellName: wellName,
                    isOnline: rigData?.tx === true,
                    createdAt: Date.now()
                };
                
                setOpenTabs(prev => [...prev, newTab]);
                setActiveTabId(selectedRigId);
                setRig(parseInt(selectedRigId));
            }
        }
    }, [openTabs, rigs, setOpenTabs, setActiveTabId]);

    // 🗂️ Sincronizar cambios de activeTabId con rig
    useEffect(() => {
        if (activeTabId) {
            const newRig = parseInt(activeTabId);
            const currentRig = parseInt(rig);
            if (newRig !== currentRig) {
                setRig(newRig);
            }
        }
    }, [activeTabId]);

    // 🎬 INICIALIZAR TAB INICIAL cuando hay rig y datos (Desktop + LiveGraphs)
    useEffect(() => {
        if (rig && rig !== 0 && !mobile && componente === 'livegraphsopt' && openTabs.length === 0 && rigs && rigs.length > 0) {
            const rigData = rigs.find(r => parseInt(r.nb_tldro_idn) === parseInt(rig));
            
            // Extraer nombre del rig y pozo
            let rigName, wellName;
            if (rigData?.pozo) {
                // Si tiene el campo pozo separado
                rigName = rigData.rig || rigData.vr_tldro_nom || `Rig ${rig}`;
                wellName = rigData.pozo;
            } else {
                // Extraer del nombre completo separado por guion
                const fullName = rigData?.vr_tldro_nom || rigData?.rig || `Rig ${rig}`;
                const parts = fullName.split('-');
                if (parts.length >= 2) {
                    rigName = parts[0].trim();
                    wellName = parts.slice(1).join('-').trim();
                } else {
                    rigName = fullName;
                    wellName = 'Sin pozo';
                }
            }
            
            const initialTab = {
                rigId: rig,
                rigName: rigName,
                wellName: wellName,
                isOnline: rigData?.tx === true,
                createdAt: Date.now()
            };
            
            setOpenTabs([initialTab]);
            setActiveTabId(rig);
        }
    }, [rig, mobile, componente, openTabs.length, rigs]);

    //--------------------------------------------------------------------

    useEffect(() => {

        setRig(localStorage.getItem("rig") ? JSON.parse(localStorage.getItem("rig")) : 0);

        const setRealVh = () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        window.addEventListener('resize', setRealVh);
        setRealVh();

        setTipoDispositivo(detectDeviceType())
        validarMobil(setMobile, setHorizontal)
        iniciarReloj()
        getRigs()
        getVariables(setVariables)
        getPermisosReportes()

        const handleBackButton = (event) => { event.preventDefault(); };
        window.addEventListener('popstate', handleBackButton);
        return () => { window.removeEventListener('popstate', handleBackButton) };
    }, [])

    const iniciarReloj = () => {
        const interval = setInterval(() => {
            setReloj(moment().format('LTS'))
        }, 1000);
        return () => clearInterval(interval);
    }

    const handleMouseEnter = (index) => { setActivoHover(index); };
    const handleMouseLeave = () => { setActivoHover(null); };
    const changeTitle = async (tittle) => { document.title = tittle; };

    useEffect(() => {
        const administracion = ['variables', 'users', 'rigs', 'plantilla', 'variablesForm', 'licencias']
        if (administracion.includes(componente) && tipo !== '1') {
            setAdminShow(false)
            setComponente('home')
        }
    }, [tipo, componenteLocalStorage])

    useEffect(() => {

        const newPath = `/${componente}`;
        window.history.pushState({ previousPath: window.location.pathname }, '', newPath);

        localStorage.setItem('componente', componente);

        if (componente !== 'variables' && componente !== 'users' && componente !== 'licencias') setAdminShow(false)
        if (mobile) {
            setToggled(false)
            setCollapsed(true)
        }

        switch (componente) {
            case 'home':
                history.replace('/home');
                changeTitle('Home')
                break;
            case 'livedata':
                history.replace('/livedata');
                changeTitle('Live Data')
                break;
            case 'largedata':
                history.replace('/largedata');
                changeTitle('Large Data')
                break;
            case 'livedataopt':
                history.replace('/livedataopt');
                changeTitle('Live Data Optimized')
                break;
            case 'livegraphs':
                history.replace('/livegraphs');
                changeTitle('Live Graphs')
                break;
            case 'livegraphsopt':
                history.replace('/livegraphsopt');
                changeTitle('Live Graphs Optimized')
                break;
            case 'pits':
                history.replace('/pits');
                changeTitle('Pits')
                break;
            case 'variables':
                history.replace('/variables');
                changeTitle('Vars')
                break;
            case 'operadoras':
                history.replace('/operadoras');
                changeTitle('Operadoras')
                break;
            case 'variablesForm':
                history.replace('/variablesForm');
                changeTitle('VarsForm')
                break;
            case 'users':
                history.replace('/users');
                changeTitle('Users')
                break;
            case 'licencias':
                history.replace('/licencias');
                changeTitle('Licencias')
                break;
            case 'myrigs':
                history.replace('/myrigs');
                changeTitle('My Rigs')
                break;
            case 'plantilla':
                history.replace('/plantillas');
                changeTitle('Plantillas')
                break;
            case 'rigs':
                history.replace('/rigs');
                changeTitle('Rigs')
                break;
            case 'doreport':
                history.replace('/doreport');
                changeTitle('Daily Operational Report')
                break;
            default:
                break;
        }

    }, [componente])

    useEffect(() => {
        if (rig !== 0 && rigs.length > 0) {
            const tengoPermiso = rigs.some((r) => parseInt(r.nb_tldro_idn) === parseInt(rig));
            if (tengoPermiso) {
                localStorage.setItem('rig', rig);
                consultarRig()
                getVariables(setVariables)
            } else {
                setRig(0);
                setRigName(undefined);
                localStorage.removeItem('rig');
                toast.warning('Seleccione un Rig válido');
                setComponente('myrigs');
            }
        }
    }, [rig, rigs])

    const consultarRig = async () => {
        if (rigs.length === 0) await getRigs()
        const rigTempo = rigs?.find((ri) => parseInt(ri.nb_tldro_idn) === parseInt(rig))
        if (rigTempo) {
            setRigName(rigTempo.vr_tldro_nom)
            localStorage.setItem('fInicial', rigTempo.dt_adt_fchreg);
        } else {
            const selectElement = document.getElementById('seleccionarRig')
            const selectedIndex = selectElement?.selectedIndex;
            const selectedOption = selectElement?.options[selectedIndex];
            const selectedText = selectedOption?.text;
            setRigName(selectedText);
        }
    }

    useEffect(() => {
        let coloresTemporales = {}
        const themesCopy = { ...themes }
        switch (theme) {
            case 'light':
                coloresTemporales = {
                    colorBg: '#ffffff',
                    colorFont: '#212529',

                    ldColorAlarm: '#dc3545',
                    ldColorBg: '#ffffff',
                    ldColorBorder: '#dee2e6',
                    ldColorFont: '#212529',
                    ldColorMeasure: '#1a5490',

                    grColorAlarm: '#dc3545',
                    grColorBg: '#ffffff',
                    grColorBorder: '#dee2e6',
                    grColorFont: '#212529',
                    grColorMeasure: '#1a5490',
                    grColor1_1: '#E74C3C',
                    grColor1_2: '#16A085',
                    grColor2_1: '#2980B9',
                    grColor2_2: '#27AE60',
                    grColor3_1: '#F39C12',
                    grColor3_2: '#8E44AD',
                    grColor4_1: '#1ABC9C',
                    grColor4_2: '#D68910',
                    grColor5_1: '#6C3483',
                    grColor5_2: '#2471A3',
                }
                break;
            case 'dark':
                coloresTemporales = {
                    colorBg: '#000000',
                    colorFont: '#ffffff',

                    ldColorAlarm: '#ff6b6b',
                    ldColorBg: '#000000',
                    ldColorBorder: '#333333',
                    ldColorFont: '#ffffff',
                    ldColorMeasure: '#45B7D1',

                    grColorAlarm: '#ff6b6b',
                    grColorBg: '#00000052',
                    grColorBorder: '#333333',
                    grColorFont: '#ffffff',
                    grColorMeasure: '#45B7D1',
                    grColor1_1: '#FF6B6B',
                    grColor1_2: '#4ECDC4',
                    grColor2_1: '#45B7D1',
                    grColor2_2: '#96CEB4',
                    grColor3_1: '#FFEAA7',
                    grColor3_2: '#DDA0DD',
                    grColor4_1: '#98D8C8',
                    grColor4_2: '#F7DC6F',
                    grColor5_1: '#BB8FCE',
                    grColor5_2: '#85C1E9',
                }
                break;
            case 'custom':
                coloresTemporales = {
                    colorBg: "#050505",
                    colorFont: "#08e740",

                    ldColorAlarm: "#ef0b0b",
                    ldColorBg: "#121212",
                    ldColorBorder: "#9c9c9c",
                    ldColorFont: "#ffffff",
                    ldColorMeasure: "#00ff1e",

                    grColorAlarm: '#ff0000',
                    grColorBg: '#ffffff',
                    grColorBorder: "#12a114",
                    grColorFont: "#2e9004",
                    grColorMeasure: "#1dfa00",
                    grColor1_1: "#07e40b",
                    grColor1_2: "#f308f7",
                    grColor2_1: "#07e40b",
                    grColor2_2: "#f308f7",
                    grColor3_1: "#07e40b",
                    grColor3_2: "#f308f7",
                    grColor4_1: "#07e40b",
                    grColor4_2: "#f308f7",
                    grColor5_1: "#07e40b",
                    grColor5_2: "#f308f7",
                }
                const colorsCustom = JSON.parse(localStorage.getItem('colorsCustom')) || {}
                if (Object.keys(colorsCustom).length > 0) coloresTemporales = colorsCustom
                themesCopy.custom.sidebar.backgroundColor = colorsCustom.colorBg || '#ffffff'
                themesCopy.custom.sidebar.color = colorsCustom.colorFont || '#000000'
                themesCopy.custom.font.color = colorsCustom.colorFont || '#000000'

                break;
            default:
                break;
        }
        setColors(coloresTemporales)
        setThemes(themesCopy)

        localStorage.setItem("theme", theme)
        
        // 🎨 Sincronizar con atributo data-theme para CSS variables
        document.documentElement.setAttribute('data-theme', theme);
        
        // 🔔 Disparar evento personalizado para que los componentes reaccionen
        window.dispatchEvent(new Event('themeChanged'));
    }, [theme])

    useEffect(() => {
        const themesCopy = { ...themes }
        themesCopy.custom.sidebar.backgroundColor = colors.colorBg || '#ffffff'
        themesCopy.custom.sidebar.color = colors.colorFont || '#000000'
        themesCopy.custom.font.color = colors.colorFont || '#000000'
        setThemes(themesCopy)
    }, [colors])

    useEffect(() => {
        sessionStorage.setItem("collapsed", collapsed);
        sessionStorage.setItem("toggled", toggled);
        sessionStorage.setItem("broken", broken);
    }, [collapsed, toggled, broken])

    useEffect(() => {
        if (rigName === undefined && rig === 0) {
            toast.warning('Seleccione un Rig')
            setComponente('myrigs')
        } else consultarRig()
    }, [rigName])

    //-------------------------------------------------------------------

    const getRigs = async () => {
        setIsLoading(true)
        const uid = JSON.parse(localStorage.getItem('token')).id
        try {
            await cargarLogos()
            const data = await getTableByIdBd(uid, 'getrigsusers')
            const rigsTemp = data.filter((rig, index, self) =>
                index === self.findIndex((t) => (
                    t.nb_tldro_idn === rig.nb_tldro_idn
                ))
            )
            setRigs(rigsTemp);
        } catch (error) {
            toast.warning('bd don\'t work');
        } finally {
            setIsLoading(false)
        }
    }

    const getPermisosReportes = async () => {
        setIsLoading(true);
        try {
            const data = await getTableByIdBd(user, 'getuserreport')
            //console.log(data);
            if (data && data.length >= 1) setReportes(data[0].acceso)
            else setReportes(false)
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    //-------------------------------------------------------------------

    const cargarLogos = async () => {
        try {
            const url = await obtenerURLImagen('gs://wellcheck-ce3d6.appspot.com/logo.png');
            const urlTw = await obtenerURLImagen('gs://wellcheck-ce3d6.appspot.com/twLogo.png');
            const url2 = await obtenerURLImagen('gs://wellcheck-ce3d6.appspot.com/logoWhite.png')
            const urlTw2 = await obtenerURLImagen('gs://wellcheck-ce3d6.appspot.com/twLogoW.png');
            setLogoTw(urlTw)
            setLogo(url);
            setLogoTwW(urlTw2)
            setLogoW(url2)
        } catch (error) {
            toast.warning("error al consultar logos")
        }
    };

    //-------------------------------------------------------------------

    const menuTw = (icono, activo, compo, titulo) => {
        return (
            <MenuItem
                icon={<i className={icono} />}
                active={componente === activo}
                onClick={() => {
                    if ((compo === 'livedata' || compo === 'livegraphs' || compo === 'livegraphsopt') && rig === 0) {
                        toast.warning('Seleccione un Rig')
                        return
                    }
                    setComponente(compo)
                }}
                className={'update-item ' + (componente === compo ? "text-info" : "")}
            >
                {titulo}
            </MenuItem>

        )
    }

    //-------------------------------------------------------------------
    return (
        <>
            <ToastContainer position="bottom-right" />

            <Config
                show={showConfig}
                handleClose={handleClose}
                colors={colors}
                setColors={setColors}
                setTheme={setTheme} theme={theme} />

            <div style={{ display: 'flex', minHeight: '100vh' }}>

                <Sidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    rtl={false}
                    breakPoint="lg"
                    rootStyles={{ color: themes[theme].sidebar.color, zIndex: 2 }}
                    backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, 1)}
                    onBackdropClick={() => setToggled(false)}
                    onBreakPoint={(broken) => setBroken(broken)} >
                    <div className={broken ? 'mt-4' : ''}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            overflowY: 'hiden',
                            maxHeight: broken ? 'calc(100vh - 48px)' : '100vh'
                        }}>

                        <div style={{ flex: 1 }} className={broken ? 'mt-2' : ''}>

                            {/* Logo Empresa Usuario */}
                            <div className=" text-center continer">

                                {mobile && (
                                    <>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-9 mt-1 ms-3" style={{ fontSize: '10px' }}>
                                                {!collapsed && (
                                                    <span className={"navbar-text "}
                                                        style={{ color: colors.colorFont }}>
                                                        {reloj} </span>
                                                )}
                                                {(componente === 'plantilla' || componente === 'variables' || componente === 'users') &&
                                                    <Help ruta={componente} />
                                                }
                                            </div>
                                            <div className={`${!collapsed ? 'col-2' : 'ms-auto'}`} >
                                                <i onClick={() => setCollapsed(!collapsed)}
                                                    style={{ cursor: 'pointer', fontSize: '12px' }}
                                                    className={"btn border-0 fa-solid text-end " + (collapsed ? 'fa-angle-right ' : 'fa-angle-left ') + (theme === 'dark' ? ' text-white' : '')}
                                                />
                                            </div>
                                        </div>
                                        <hr className='mt-1 mb-0' />
                                    </>
                                )}

                                <img src={theme === 'dark' ? logoTwW : logoTw}
                                    className="img-fluid mx-auto my-3"
                                    style={{ width: mobile ? '150px' : '200px' }}
                                    alt="Logo"
                                />

                                <div>
                                    {/* {!collapsed && (selectRig())} */}
                                    {/* User */}
                                    <div className="row align-items-center">
                                        <div className="col col align-self-center">
                                            <p className="text-center pe-2 mb-0"
                                                data-bs-toggle="modal"
                                                data-bs-target="#ModificarClave"
                                                id="modalModificar"
                                                title="Cambiar clave"
                                                style={{
                                                    fontSize: mobile ? '10px' : "12px",
                                                    cursor: "pointer"
                                                }}>
                                                {user.toUpperCase()}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="mb-2 mt-2 bg-light hr-menu" />

                            <ProMenu>
                                {menuTw('fa fa-home', 'home', 'home', 'Home')}
                                <hr className="m-0 bg-light hr-menu" />
                                {menuTw('fa fa-braille', 'livedataopt', 'livedataopt', 'Live Data Opt')}
                                <hr className="m-0 bg-light hr-menu" />
                                {menuTw('fa fa-chart-line', 'livegraphsopt', 'livegraphsopt', 'Graphs Opt')}
                                <hr className="m-0 bg-light hr-menu" />
                                {/* {menuTw('fa fa-water', 'pits', 'pits', 'Pits')}
                                <hr className="m-0 bg-light" /> */}
                                {menuTw('fa fa-helmet-safety', 'myrigs', 'myrigs', 'My Rigs')}
                                <hr className="m-0 bg-light hr-menu" />

                                {/* Administracion---------------------------------------------------------------- */}

                                {tipo === '1' && (
                                    <>
                                        <SubMenu
                                            open={adminShow}
                                            label="Administración"
                                            icon={<i className="fa-solid fa-user-shield"></i>}
                                            className={"update-item " + (adminShow || (componente === "variables" || componente === "users") ? 'text-info' : '')}
                                            onClick={() => setAdminShow(!adminShow)}>

                                            <MenuItem
                                                className={'update-item ' + (componente === "variables" || activoHover === 40 ? "active" : "")}
                                                onClick={() => setComponente('variables')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(40)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-solid fa-map-signs me-3 ">
                                                </span>{" "}
                                                Variables
                                            </MenuItem>

                                            <MenuItem
                                                className={'update-item ' + (componente === "rigs" || activoHover === 41 ? "active" : "")}
                                                onClick={() => setComponente('rigs')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(41)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-solid fa-oil-well me-3 " />{" "}
                                                Rigs
                                            </MenuItem>

                                            <MenuItem
                                                className={'update-item ' + (componente === "users" || activoHover === 42 ? "active" : "")}
                                                onClick={() => setComponente('users')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(42)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-solid fa-users-gear me-3"></span>{" "}
                                                Usuarios
                                            </MenuItem>

                                            <MenuItem
                                                className={'update-item ' + (componente === "operadoras" || activoHover === 43 ? "active" : "")}
                                                onClick={() => setComponente('operadoras')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(43)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-solid fa-user-tie me-3"></span>{" "}
                                                Operadoras
                                            </MenuItem>

                                            <MenuItem
                                                className={'update-item ' + (componente === "licencias" || activoHover === 47 ? "active" : "")}
                                                onClick={() => setComponente('licencias')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(47)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-solid fa-key me-3"></span>{" "}
                                                Licencias
                                            </MenuItem>

                                            <MenuItem
                                                className={'update-item ' + (componente === "plantilla" || activoHover === 46 ? "active" : "")}
                                                onClick={() => setComponente('plantilla')}
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => handleMouseEnter(46)}
                                                onMouseLeave={handleMouseLeave}>
                                                <span className="fa-regular fa-object-group me-3"></span>{" "}
                                                Plantillas
                                            </MenuItem>

                                            {!mobile && (
                                                <MenuItem
                                                    className={'update-item ' + (componente === "variablesForm" || activoHover === 41 ? "active" : "")}
                                                    onClick={() => setComponente('variablesForm')}
                                                    style={{ cursor: 'pointer' }}
                                                    onMouseEnter={() => handleMouseEnter(41)}
                                                    onMouseLeave={handleMouseLeave}>
                                                    <span className="fa-solid fa-map-signs me-3 ">
                                                    </span>{" "}
                                                    Formulación
                                                </MenuItem>
                                            )}

                                        </SubMenu>
                                        <hr className="m-0 bg-light hr-menu" />
                                    </>
                                )}

                                <hr className="m-0 bg-light hr-menu" />

                                <LogoutButton theme={theme} />

                            </ProMenu>

                        </div>

                        <img src={theme === 'light' ? logo : logoW}
                            className="img-fluid mx-auto"
                            style={{ width: mobile ? '150px' : '200px' }}
                            alt="Logo" />

                        {!mobile && (
                            <i onClick={() => setCollapsed(!collapsed)}
                                className={"btn border-0 fa-solid text-end " + (collapsed ? 'fa-angle-right ' : 'fa-angle-left ') + (theme === 'dark' ? ' text-white' : '')}
                            />
                        )}
                    </div>
                </Sidebar >

                <main className="w-100" style={{ backgroundColor: themes[theme].sidebar.backgroundColor }}>

                    {/* Header */}
                    <nav className="navbar navbar-expand-lg fixed-top p-0 border-bottom"
                        style={{
                            backgroundColor: hexToRgba(themes[theme].sidebar.backgroundColor, 1),
                            marginLeft: broken || mobile ? '' : (!collapsed ? '250px' : '80px'),
                            transition: 'margin-left 0.3s ease',
                            overflowX: 'hidden'
                        }}>
                        <div className="container-fluid m-0 p-0" style={{ overflowX: 'hidden' }}>
                            <div className="d-flex align-items-center w-100 justify-content-between px-2" style={{ overflowX: 'hidden' }}>
                                {/* Botón menú/sidebar */}
                                <div className="d-flex align-items-center z-3" style={{ minWidth: 'fit-content' }}>
                                    {broken
                                        ? <i className={"btn fa-solid fa-bars z-3 "}
                                            style={{ color: colors.colorFont }}
                                            onClick={() => setToggled(!toggled)} />

                                        : <i onClick={() => setCollapsed(!collapsed)}
                                            className={"btn border-0 fa-solid " +
                                                (collapsed ? 'fa-angle-right ' : 'fa-angle-left ') +
                                                (theme === 'dark' ? 'text-white' : '')}
                                        />
                                    }
                                </div>

                                {/* Centro: Componente info o selector rig */}
                                <div className="flex-grow-1 d-flex align-items-center z-3" style={{
                                    justifyContent: ['livegraphsopt', 'livedataopt', 'home', 'myrigs', 'variables', 'operadoras', 'users', 'plantilla', 'rigs'].includes(componente) ? 'flex-start' : 'center',
                                    gap: mobile ? '8px' : '16px',
                                    paddingLeft: ['livegraphsopt', 'livedataopt', 'home', 'myrigs', 'variables', 'operadoras', 'users', 'plantilla', 'rigs'].includes(componente) ? '8px' : '0',
                                    maxWidth: ['livegraphsopt', 'livedataopt', 'home', 'myrigs', 'variables', 'operadoras', 'users', 'plantilla', 'rigs'].includes(componente) && !mobile ? 'calc(100vw - 400px)' : 'auto',
                                    overflow: 'hidden'
                                }}>

                                    {/* Selector de Rigs - Solo mostrar cuando NO hay pestañas o en mobile o en otro componente */}
                                    {(!['livegraphsopt', 'livedataopt', 'home', 'myrigs', 'variables', 'operadoras', 'users', 'plantilla', 'rigs'].includes(componente) || mobile || openTabs.length === 0) && (
                                        <span style={{ whiteSpace: 'nowrap' }}>
                                            <select
                                                value={rig}
                                                onChange={(e) => setRig(parseInt(e.target.value))}
                                                disabled={loading || loadingMore}
                                                style={{
                                                    fontSize: mobile ? '10px' : '14px',
                                                    padding: '3px 6px',
                                                    backgroundColor: colors.colorBg,
                                                    color: colors.colorFont,
                                                    border: `1px solid ${colors.colorFont}`,
                                                    borderRadius: '4px',
                                                    maxWidth: mobile ? '150px' : '300px'
                                                }}
                                            >
                                                <option value={0}>Seleccionar</option>
                                                {rigs && rigs.length > 0 && rigs.map((rigItem) => (
                                                    <option key={rigItem.nb_tldro_idn} value={rigItem.nb_tldro_idn}>
                                                        {rigItem.vr_tldro_nom}
                                                    </option>
                                                ))}
                                            </select>
                                        </span>
                                    )}

                                    {/* Pestañas de Rigs - Solo en desktop y en componentes con soporte de pestañas */}
                                    {!mobile && ['livegraphsopt', 'livedataopt', 'home', 'myrigs', 'variables', 'operadoras', 'users', 'plantilla', 'rigs'].includes(componente) && openTabs.length > 0 && (
                                        <RigTabs
                                            openTabs={openTabs}
                                            activeTabId={activeTabId}
                                            onTabChange={handleTabChange}
                                            onTabClose={handleTabClose}
                                            onAddTab={handleAddTab}
                                            theme={theme}
                                        />
                                    )}

                                    {/* Selector de Rig flotante para agregar nuevo tab */}
                                    {showRigSelectorInTabs && (() => {
                                        // Filtrar rigs que no están abiertos y ordenar por estado de transmisión
                                        const availableRigs = rigs
                                            .filter(rigItem => {
                                                // Excluir rigs que ya están abiertos en pestañas
                                                const isAlreadyOpen = openTabs.some(tab => 
                                                    parseInt(tab.rigId) === parseInt(rigItem.nb_tldro_idn)
                                                );
                                                return !isAlreadyOpen;
                                            })
                                            .sort((a, b) => {
                                                // Primero los que transmiten (tx = true), luego los que no
                                                if (a.tx && !b.tx) return -1;
                                                if (!a.tx && b.tx) return 1;
                                                return 0;
                                            });

                                        // Debug: Log para verificar filtrado
                                        //console.log('🔍 [Selector] Pestañas abiertas:', openTabs.map(t => t.rigId));
                                        //console.log('🔍 [Selector] Rigs disponibles:', availableRigs.map(r => r.nb_tldro_idn));

                                        return (
                                            <div style={{
                                                position: 'fixed',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                zIndex: 9999,
                                                backgroundColor: colors.colorBg,
                                                padding: '20px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                                border: `2px solid ${colors.colorFont}`,
                                                minWidth: '350px',
                                                maxWidth: '500px'
                                            }}>
                                                <div style={{ 
                                                    marginBottom: '15px', 
                                                    color: colors.colorFont, 
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    textAlign: 'center'
                                                }}>
                                                    <i className="fa-solid fa-plus-circle me-2"></i>
                                                    Seleccionar Rig para nueva pestaña
                                                </div>
                                                
                                                <div style={{
                                                    maxHeight: '400px',
                                                    overflowY: 'auto',
                                                    marginBottom: '15px',
                                                    border: `1px solid ${colors.colorFont}`,
                                                    borderRadius: '4px'
                                                }}>
                                                    {availableRigs.length > 0 ? (
                                                        availableRigs.map((rigItem) => (
                                                            <div
                                                                key={rigItem.nb_tldro_idn}
                                                                onClick={() => handleSelectRigFromTabs(rigItem.nb_tldro_idn)}
                                                                style={{
                                                                    padding: '12px 16px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: `1px solid ${hexToRgba(colors.colorFont, 0.2)}`,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '12px',
                                                                    transition: 'background-color 0.2s',
                                                                    backgroundColor: 'transparent'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hexToRgba(colors.colorFont, 0.1)}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            >
                                                                {/* Indicador de estado TX */}
                                                                <i className="fa-solid fa-circle" 
                                                                   style={{ 
                                                                       color: rigItem.tx ? '#28a745' : '#dc3545',
                                                                       fontSize: '12px',
                                                                       minWidth: '12px'
                                                                   }}></i>
                                                                
                                                                {/* Nombre del rig */}
                                                                <div style={{ 
                                                                    flex: 1,
                                                                    color: rigItem.tx ? '#28a745' : colors.colorFont,
                                                                    fontWeight: rigItem.tx ? 'bold' : 'normal',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    {rigItem.vr_tldro_nom}
                                                                </div>
                                                                
                                                                {/* Badge de estado */}
                                                                {rigItem.tx && (
                                                                    <span style={{
                                                                        fontSize: '10px',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '12px',
                                                                        backgroundColor: '#28a745',
                                                                        color: '#ffffff',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        EN VIVO
                                                                    </span>
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div style={{
                                                            padding: '20px',
                                                            textAlign: 'center',
                                                            color: colors.colorFont,
                                                            opacity: 0.6
                                                        }}>
                                                            <i className="fa-solid fa-info-circle me-2"></i>
                                                            No hay más rigs disponibles
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <button
                                                    onClick={() => setShowRigSelectorInTabs(false)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        backgroundColor: '#dc3545',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
                                                >
                                                    <i className="fa-solid fa-times me-2"></i>
                                                    Cancelar
                                                </button>
                                            </div>
                                        );
                                    })()}

                                    {/* Overlay para el selector flotante */}
                                    {showRigSelectorInTabs && (
                                        <div
                                            onClick={() => setShowRigSelectorInTabs(false)}
                                            style={{
                                                position: 'fixed',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                zIndex: 9998
                                            }}
                                        />
                                    )}

                                    {/* Estado Rig */}
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        <strong className={enVivo ? 'stat-estado-live' : (loading ? 'stat-estado-loading' : 'stat-estado-standby')}
                                            style={{ fontSize: mobile ? '9px' : '12px' }}>
                                            {loading
                                                ? <><i className="fa-solid fa-spinner fa-spin"></i> {!mobile && ' CARGANDO...'}</>
                                                : (enVivo
                                                    ? <><i className="fa-solid fa-circle color-success"></i> {!mobile && ' EN VIVO'}</>
                                                    : <><i className="fa-solid fa-pause color-warning"></i> {!mobile && ' STANDBY'}</>)}
                                        </strong>
                                    </span>

                                </div>

                                {/* Derecha: Hora y botones */}
                                <div className="d-flex align-items-center z-3"
                                    style={{
                                        fontSize: mobile ? '12px' : '16px',
                                        whiteSpace: 'nowrap',
                                        gap: mobile ? '0.5rem' : '1rem',
                                        minWidth: 'fit-content'
                                    }}
                                >

                                    {!mobile && (
                                        <span
                                            className="navbar-text me-2"
                                            style={{
                                                color: colors.colorFont,
                                                minWidth: 0
                                            }}>
                                            {reloj}
                                        </span>
                                    )}

                                    <div className="btn-group">

                                        {(componente !== 'livedataopt' && rig !== 0) && (
                                            <i
                                                className={`btn border-0 fa-solid fa-table ${mobile ? ' pe-1' : ''}`}
                                                title='Live Data'
                                                style={{
                                                    color: colors.colorFont,
                                                    fontSize: mobile ? '15px' : '20px',
                                                    minWidth: 0
                                                }}
                                                onClick={() => setComponente('livedataopt')}
                                            />
                                        )}

                                        {(componente !== 'livegraphsopt' && rig !== 0) && (
                                            <i
                                                className={`btn border-0 fa-solid fa-chart-line ${mobile ? ' pe-1' : ''}`}
                                                title='Live Graphs'
                                                style={{
                                                    color: colors.colorFont,
                                                    fontSize: mobile ? '15px' : '20px',
                                                    minWidth: 0
                                                }}
                                                onClick={() => setComponente('livegraphsopt')}
                                            />
                                        )}

                                        {(componente !== 'doreport' && rig !== 0) && (reportes === 1 || tipo === '1') && (
                                            <i
                                                className={`btn border-0 fa-solid fa-book ${mobile ? ' pe-1' : ''}`}
                                                title='Daily Operational Report'
                                                style={{
                                                    color: colors.colorFont,
                                                    fontSize: mobile ? '15px' : '20px',
                                                    minWidth: 0
                                                }}
                                                onClick={() => setComponente('doreport')}
                                            />
                                        )}

                                        <i className={`btn border-0 fa-solid fa-gear mb-1 ${mobile ? 'pe-0' : ''}`}
                                            style={{
                                                color: colors.colorFont,
                                                fontSize: mobile ? '15px' : '20px',
                                                minWidth: 0
                                            }}
                                            title='Configuración de Tema'
                                            onClick={() => setShowConfig(!showConfig)}
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                    </nav>
                    {/* Header */}

                    <div className={`container-fluid text-center ${mobile ? (horizontal ? 'mt-2 pt-4 px-0' : ' ') : 'mt-5 p-0'} `}
                        style={{
                            paddingTop: mobile ? (horizontal ? '60px' : '40px') : '70px',
                            marginTop: mobile ? '' : '2.5rem !important'
                        }}>
                        {isLoading
                            ? <LoaderES />
                            : <>

                                {componente === 'home' &&
                                    <Home
                                        broken={broken}
                                        collapsed={collapsed}
                                        setRig={setRig}
                                        setComponente={setComponente}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        reportes={reportes}
                                        
                                        // Tab props (solo desktop)
                                        openTabs={!mobile ? openTabs : undefined}
                                        setOpenTabs={!mobile ? setOpenTabs : undefined}
                                        activeTabId={!mobile ? activeTabId : undefined}
                                        setActiveTabId={!mobile ? setActiveTabId : undefined}
                                        showRigSelector={!mobile ? showRigSelectorInTabs : undefined}
                                        setShowRigSelector={!mobile ? setShowRigSelectorInTabs : undefined}
                                        
                                        // Cache props (solo desktop)
                                        getCachedRigData={!mobile ? getCachedRigData : undefined}
                                        setCachedRigData={!mobile ? setCachedRigData : undefined}
                                        updateCachedRigData={!mobile ? updateCachedRigData : undefined}
                                        clearCachedRigData={!mobile ? clearCachedRigData : undefined}
                                        
                                        rigs={rigs}
                                        tipo={tipo}
                                        theme={theme}
                                    />
                                }

                                {componente === 'myrigs' &&
                                    <MyRigs
                                        broken={broken}
                                        collapsed={collapsed}
                                        setRig={setRig}
                                        setComponente={setComponente}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        tipo={tipo}
                                        colors={colors}
                                        reportes={reportes}
                                        
                                        // Tab props (solo desktop)
                                        openTabs={!mobile ? openTabs : undefined}
                                        setOpenTabs={!mobile ? setOpenTabs : undefined}
                                        activeTabId={!mobile ? activeTabId : undefined}
                                        setActiveTabId={!mobile ? setActiveTabId : undefined}
                                        showRigSelector={!mobile ? showRigSelectorInTabs : undefined}
                                        setShowRigSelector={!mobile ? setShowRigSelectorInTabs : undefined}
                                        
                                        // Cache props (solo desktop)
                                        getCachedRigData={!mobile ? getCachedRigData : undefined}
                                        setCachedRigData={!mobile ? setCachedRigData : undefined}
                                        updateCachedRigData={!mobile ? updateCachedRigData : undefined}
                                        clearCachedRigData={!mobile ? clearCachedRigData : undefined}
                                        
                                        rigs={rigs}
                                        theme={theme}
                                    />
                                }

                                <div className="m-0 p-0 "
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        display: componente === 'livegraphsopt' ? 'flex' : 'none',
                                        flexDirection: 'row',
                                        gap: '8px'
                                    }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <LiveGraphsOptimized
                                        rig={rig}
                                        setRig={setRig}
                                        mobile={mobile}
                                        horizontal={horizontal}
                                        variables={variables}
                                        broken={broken}
                                        collapsed={collapsed}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        componente={componente} setComponente={setComponente}
                                        setCollapsed={setCollapsed}
                                        setToggled={setToggled}
                                        tipoDispositivo={tipoDispositivo}
                                        ventana={componente}
                                        tipo={tipo}
                                        rigs={rigs}
                                        reportes={reportes}

                                        loading={loading}
                                        setLoading={setLoading}
                                        loadingMore={loadingMore}
                                        setLoadingMore={setLoadingMore}
                                        enVivo={enVivo}
                                        setEnVivo={setEnVivo}

                                        themes={themes}
                                        theme={theme}

                                        // Tab props
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}

                                        // Cache props
                                        getCachedRigData={getCachedRigData}
                                        setCachedRigData={setCachedRigData}
                                        updateCachedRigData={updateCachedRigData}
                                        clearCachedRigData={clearCachedRigData}

                                        />
                                    </div>
                                </div>

                                {componente === 'livedataopt' &&
                                    <LiveDataOpt
                                        rig={rig}
                                        setRig={setRig}
                                        mobile={mobile}
                                        horizontal={horizontal}
                                        variables={variables}
                                        broken={broken}
                                        collapsed={collapsed}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        componente={componente} setComponente={setComponente}
                                        setCollapsed={setCollapsed}
                                        setToggled={setToggled}
                                        tipoDispositivo={tipoDispositivo}
                                        ventana={componente}
                                        tipo={tipo}
                                        rigs={rigs}
                                        reportes={reportes}

                                        loading={loading}
                                        setLoading={setLoading}
                                        enVivo={enVivo}
                                        setEnVivo={setEnVivo}

                                        themes={themes}
                                        theme={theme}
                                        
                                        // Tab props (solo desktop)
                                        openTabs={!mobile ? openTabs : undefined}
                                        setOpenTabs={!mobile ? setOpenTabs : undefined}
                                        activeTabId={!mobile ? activeTabId : undefined}
                                        setActiveTabId={!mobile ? setActiveTabId : undefined}
                                        showRigSelector={!mobile ? showRigSelectorInTabs : undefined}
                                        setShowRigSelector={!mobile ? setShowRigSelectorInTabs : undefined}
                                        
                                        // Cache props (solo desktop)
                                        getCachedRigData={!mobile ? getCachedRigData : undefined}
                                        setCachedRigData={!mobile ? setCachedRigData : undefined}
                                        updateCachedRigData={!mobile ? updateCachedRigData : undefined}
                                        clearCachedRigData={!mobile ? clearCachedRigData : undefined}
                                    />
                                }

                                <div className="m-0 p-0 "
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        display: componente === 'doreport' ? 'block' : 'none'
                                    }}>
                                    <DOReport
                                        broken={broken}
                                        collapsed={collapsed}
                                        setComponente={setComponente}
                                        mobile={mobile} horizontal={horizontal}
                                        user={user}
                                        uid={uId}
                                        tipo={tipo}
                                        colors={colors}
                                        rig={rig}
                                        setRig={setRig}
                                        rigs={rigs}
                                        reportes={reportes}
                                    />
                                </div>

                                {componente === 'variables'
                                    && <Variables
                                        broken={broken}
                                        collapsed={collapsed}
                                        mobile={mobile}
                                        variables={variables}
                                        setVariables={setVariables}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}
                                        theme={theme} />
                                }

                                {componente === 'operadoras'
                                    && <Operadoras
                                        broken={broken}
                                        collapsed={collapsed}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}
                                        theme={theme} />
                                }

                                {componente === 'variablesForm'
                                    && <VariablesForm
                                        rig={rig}
                                        rigs={rigs}
                                        setRig={setRig} mobile={mobile}
                                        variables={variables}
                                        broken={broken}
                                        collapsed={collapsed}
                                        user={user}
                                        uid={uId}
                                        colors={colors} />
                                }

                                {componente === 'users'
                                    && <Users
                                        broken={broken}
                                        collapsed={collapsed}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}
                                        theme={theme} />
                                }

                                {componente === 'licencias'
                                    && <Licencias
                                        broken={broken}
                                        collapsed={collapsed}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        colors={colors} />
                                }

                                {componente === 'plantilla'
                                    && <Plantillas
                                        broken={broken}
                                        collapsed={collapsed}
                                        mobile={mobile}
                                        variables={variables}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}
                                        theme={theme} />
                                }

                                {componente === 'rigs'
                                    && <Rigs
                                        broken={broken}
                                        collapsed={collapsed}
                                        setComponente={setComponente}
                                        mobile={mobile}
                                        user={user}
                                        uid={uId}
                                        colors={colors}
                                        openTabs={openTabs}
                                        setOpenTabs={setOpenTabs}
                                        activeTabId={activeTabId}
                                        setActiveTabId={setActiveTabId}
                                        showRigSelector={showRigSelectorInTabs}
                                        setShowRigSelector={setShowRigSelectorInTabs}
                                        theme={theme} />
                                }
                            </>
                        }
                    </div>
                </main >

            </div >

        </>
    )
}

export default Menu            